import React, { useMemo } from 'react';
import { useHistory } from 'react-router-dom';

import { useAppContext } from '@prisjakt/ui-app-context';

import { NavigationSliceView } from 'src/areas/product-collection/components/navigation/navigation-component';

import { trackKeywordSearchPageCategoryClick } from '../../tracking';

import {
  CategoryResultsKwlp as CategoryResultsType,
  FilterNode,
  Maybe,
} from 'src/types';
import { FacetLink } from 'src/areas/product-collection/components/navigation/types';

type NewCategories = CategoryResultsType['nodes'] | undefined;

type Props = {
  categories: NewCategories;
  wideContent: boolean;
};

export const CategoryResults = (props: Props) => {
  const { categories, wideContent } = props;
  const { market, linkTo } = useAppContext();
  const history = useHistory();
  const categoriesFromNewSearch = categories as NewCategories;
  const prepareCategoryPath = (
    filters: Maybe<Maybe<FilterNode>[]> | undefined
  ) => {
    const urlFilters = filters?.reduce(
      (acc: string[][], f: Maybe<FilterNode>) => {
        const { type, detailId, value, valueId } = f ?? {};

        if (!type) {
          return acc;
        }

        if (type === 'boolean' && detailId && value) {
          acc.push([`b_${detailId}`, value.toString()]);
        }

        if (type === 'text' && detailId && valueId) {
          acc.push([detailId.toString(), valueId.toString()]);
        }

        if (type === 'numeric' && detailId && value) {
          acc.push([detailId, value]);
        }

        return acc;
      },
      []
    );

    const queryStr = urlFilters && new URLSearchParams(urlFilters).toString();

    return `?${queryStr}`;
  };
  const formattedLinks: FacetLink[] = useMemo(
    () =>
      categoriesFromNewSearch?.map(category => {
        const { filters, path: catPath, id, name, type, image } =
          category ?? {};
        const preDefinedParams = prepareCategoryPath(filters);
        const path = preDefinedParams
          ? `${catPath}${preDefinedParams}`
          : catPath;
        return {
          id: id || '',
          value: name || '',
          selected: false,
          path:
            category && type === 'classic' && market.useClassicUrls
              ? linkTo('category', category)
              : path,
          imageUrl: image,
          indexable: true,
        };
      }) ?? [],
    [categoriesFromNewSearch, linkTo, market.useClassicUrls]
  );

  return categories?.length ? (
    <NavigationSliceView
      links={formattedLinks}
      onClickPreventDefault
      onClick={(link: FacetLink) => {
        if (link.path) {
          history.push(link.path);
          trackKeywordSearchPageCategoryClick(link.value, link.id);
        }
      }}
      {...(wideContent && { itemLimit: 9 })}
    />
  ) : null;
};
